import React from "react";
import FormLabel from "./FormLabel";
import FormTextField from "./FormTextField";

/**
 * Host-private or payment note. Defaults to textarea; use as="input" for single-line.
 */
export default function HostNoteField({
  value,
  onChange,
  label = "Private note",
  placeholder = "Only you can see this",
  required = false,
  error,
  id,
  as = "textarea",
  testId,
  className = "",
  rows,
  minHeightClass = "min-h-[72px]",
}) {
  if (as === "input") {
    return (
      <FormTextField
        id={id}
        label={label}
        required={required}
        error={error}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        className={className}
      />
    );
  }

  return (
    <FormTextField
      id={id}
      label={label}
      required={required}
      error={error}
      as="textarea"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
      className={`${minHeightClass} ${className}`.trim()}
      rows={rows}
    />
  );
}

/** Compact note without FormTextField margin conventions — for dense modals. */
export function HostNoteTextarea({
  value,
  onChange,
  label = "Private note",
  placeholder = "Only you can see this",
  testId,
  className = "mt-2 min-h-[72px]",
  maxLength,
}) {
  return (
    <label className="block">
      <FormLabel className="block">{label}</FormLabel>
      <textarea
        className={`field ${className}`.trim()}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        data-testid={testId}
      />
    </label>
  );
}
